<template>
  <div
    class="lang_selector"
    v-click-outside="closeOutside"
  >
    <button
      class="lang_btn gap-5 medium-s font-family-2"
      :class="[isOpen && 'opened']"
      style="padding: 3px 12px"
      @click="toggleOpen"
    >
      <img
        :src="selectedLang.image"
        alt="Country language flag"
        class="language_image"
        height="30"
        width="30"
      />
    </button>

    <Transition
      :name="windowInnerWidth <= 1200 ? 'profile_menu-mobile' : 'lang_menu'"
    >
      <div
        class="languages_container d-flex-column justify-start align-start gap-0"
        v-if="isOpen"
      >
        <div class="d-flex-row height-max-content" style="padding: 12px">
          <h6 class="t-white font-family-1 title-h6 f-w-600">
            {{ $t("app.select_language") }}
          </h6>
        </div>
        <div class="button_grid_container">
          <button
            class="t-white medium-l font-family-2 gap-5 lang_change_btn"
            @click="changeLanguage(lang.param)"
            :class="[selectedLang.param === lang.param && 'active']"
            v-for="lang in langs"
            :key="lang.param"
          >
            <img
              :src="lang.image"
              alt="Country language flag"
              class="language_image"
              height="30"
              width="30"
            />

            {{ lang.title }}
          </button>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";

// HOOKS
const { locale, setLocale } = useI18n();

// REACTIVE VARIABLES
const isOpen = ref(false);
const selectedLang = ref(langs.find((lang) => lang.param === locale.value));
// const selectedLang = computed(() => {
//   return langs.find((lang) => lang.param === locale.value);
// });
const compLang = computed(() => locale.value);
// METHODS
const closeOutside = () => {
  isOpen.value = false;
};
const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};

const changeLanguage = (locale) => {
  setLocale(locale);
  let locLang = langs.find((lang) => lang.param === locale);
  selectedLang.value = locLang;
  toggleOpen();
};
const windowInnerWidth = computed(() => {
  if (!window?.innerWidth) {
    return 0;
  } else return window.innerWidth;
});
</script>
